if (!window.__cardProductQuickAddInitialized) {
  window.__cardProductQuickAddInitialized = true;

  const findTargetButton = (trigger) => {
    if (!trigger) return null;

    const targetId = trigger.dataset?.quickAddTarget;
    if (targetId) {
      const byId = document.getElementById(targetId);
      if (byId) return byId;
    }

    const cardRoot = trigger.closest('.card');
    if (!cardRoot) return null;

    return cardRoot.querySelector('.quick-add__submit[name="add"]');
  };

  const triggerStates = new WeakMap();

  const clearTriggerState = (trigger) => {
    const state = triggerStates.get(trigger);
    if (!state) return;
    state.observer?.disconnect();
    state.timeouts?.forEach((timeoutId) => clearTimeout(timeoutId));
    triggerStates.delete(trigger);
  };

  const setTriggerLoading = (trigger, isLoading) => {
    if (!trigger) return;
    const spinner = trigger.querySelector('.quick-add-trigger__spinner');
    const icon = trigger.querySelector('.quick-add-modal__icon');
    trigger.classList.toggle('quick-add-trigger--loading', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
    if (icon) {
      if (isLoading) {
        icon.setAttribute('aria-hidden', 'true');
      } else {
        icon.removeAttribute('aria-hidden');
      }
    }
    if (isLoading) {
      trigger.setAttribute('aria-disabled', 'true');
    } else {
      trigger.removeAttribute('aria-disabled');
    }
  };

  const isTargetLoading = (button) => !!button && button.classList.contains('loading');

  const monitorTargetButton = (trigger, targetButton) => {
    clearTriggerState(trigger);

    const settle = () => {
      if (!trigger.classList.contains('quick-add-trigger--loading')) return;
      if (!isTargetLoading(targetButton)) {
        clearTriggerState(trigger);
        setTriggerLoading(trigger, false);
      }
    };

    const observer = new MutationObserver(settle);
    observer.observe(targetButton, { attributes: true, attributeFilter: ['class'] });

    const earlyCheck = window.setTimeout(settle, 75);
    const fallback = window.setTimeout(settle, 8000);

    triggerStates.set(trigger, {
      observer,
      timeouts: [earlyCheck, fallback],
    });
  };

  const triggerQuickAdd = (trigger) => {
    if (!trigger || trigger.classList.contains('quick-add-trigger--loading')) return;

    const targetButton = findTargetButton(trigger);
    if (!targetButton) return;

    if (targetButton.matches('[aria-disabled="true"], :disabled')) {
      targetButton.focus();
      return;
    }

    setTriggerLoading(trigger, true);
    monitorTargetButton(trigger, targetButton);
    targetButton.click();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-add-target]');
    if (!trigger) return;

    event.preventDefault();
    triggerQuickAdd(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented) return;

    const isActivationKey = event.key === 'Enter' || event.key === ' ';
    if (!isActivationKey || event.altKey || event.ctrlKey || event.metaKey) return;

    const trigger = event.target.closest('[data-quick-add-target]');
    if (!trigger) return;

    event.preventDefault();
    triggerQuickAdd(trigger);
  });
}
